import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {UsersService} from '../../users/service/users.service';
import * as servers from '../../../services/api/servers';
import {DomSanitizer} from '@angular/platform-browser';


@Component({
  selector: 'app-tab-group-reporting',
  templateUrl: './tab-group-dashboard.component.html',
  styleUrls: ['./tab-group-dashboard.component.scss']
})
export class TabGroupDashboardComponent extends BaseGeneralComponent implements OnInit {
  selectedIndex: any;
  sectionId: string;

  powerBIlink;

  constructor(private _Activatedroute: ActivatedRoute,
              private userService: UsersService,
              private _domSanitizer: DomSanitizer) {
    super();
    this.sectionId = this.SECTIONS.MONTHLY_CHARGES;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    _Activatedroute.queryParams.subscribe(params => {
      this.selectedIndex = params['selectedIndex'];
    });
  }

  ngOnInit() {

    let url = '';
    switch (servers.viewMode) {
      case 'DEV':
        url = 'https://app.powerbi.com/reportEmbed?reportId=97668af4-f079-4248-a499-a8249d604e8e&autoAuth=true&ctid=c1aee0b1-83f4-4518-a226-e7508aec4c2d&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D';
        break;
      case 'CERT':
        url = 'https://app.powerbi.com/reportEmbed?reportId=cd2653e0-41a4-4aa4-8ed8-7f3222c00ae6&autoAuth=true&ctid=c1aee0b1-83f4-4518-a226-e7508aec4c2d&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D';
        break;
      case 'PROD':
        url = 'https://app.powerbi.com/reportEmbed?reportId=979bd4a0-c0f4-4807-b427-903668f110ad&autoAuth=true&ctid=c1aee0b1-83f4-4518-a226-e7508aec4c2d&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D';
        break;
      default:
        url = 'https://app.powerbi.com/reportEmbed?reportId=97668af4-f079-4248-a499-a8249d604e8e&autoAuth=true&ctid=c1aee0b1-83f4-4518-a226-e7508aec4c2d&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D';
      break;

    }

    this.powerBIlink = this._domSanitizer.bypassSecurityTrustResourceUrl(url)


    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
  }

}
